// Base URL for backend function
// Prefer environment variable when available. Otherwise, default to the
// deployed Cloud Run URL provided for the email function.
// Example to override for classic Firebase Functions:
//   REACT_APP_FUNCTIONS_BASE_URL=https://us-central1-YOUR_PROJECT.cloudfunctions.net
// For local emulator, set REACT_APP_FUNCTIONS_BASE_URL to your emulator URL:
//   http://127.0.0.1:5001/universaldrive/us-central1
export const FIREBASE_FUNCTION_URL =
  (process.env.REACT_APP_FUNCTIONS_BASE_URL as string) ||
  "https://sendemail-awxo6buqpa-uc.a.run.app";

// Google reCAPTCHA Enterprise site key (frontend only)
// Prefer environment variable. Falls back to provided production key.
export const RECAPTCHA_SITE_KEY =
  (process.env.REACT_APP_RECAPTCHA_SITE_KEY as string) ||
  "6Lcp5CgsAAAAAE7GUl3khIGMvfLYTuZDrB3Zv6FR";